import dynamic       from "next/dynamic";
import { useRouter } from "next/router";

import { isPageRoute }            from "_common/utils";
import Typography                 from "_components/atoms/typography";
import { updateThankForDonation } from "_components/pages/studio/api";

import useStyles from "./styles";

const LargeStickerComment = dynamic ( () => import ( "./components/largeStickerComment" ) );
const MagicChatComment    = dynamic ( () => import ( "./components/magicChatComment" ) );
const NormalComment       = dynamic ( () => import ( "./components/normalComment" ) );
const SmallStickerComment = dynamic ( () => import ( "./components/smallStickerComment" ) );

const Component = ( {
	comment,
	isStreamer,
	isPopUpOpen,
	onClickOptions,
	hideMenuOptionBtn,
	showThanksBtn,
	isModerator,
	emotesList,
	userPopover
} ) => {
	const router       = useRouter ();
	const { classes }  = useStyles ( undefined, { name: "styles" } );
	const isStudioPage = isPageRoute ( { router, page: "studio" } );

	const sayThanksHandler = () => {
		if ( comment.thanked ) return;

		updateThankForDonation ( {
			sessionId : comment.broadcastSessionId,
			commentId : comment.id
		} );
	};

	if ( comment.isDeletedByUser ) {
		return (
			<div className = { classes.deleteComment }>
				<Typography title = { "Comment has been deleted." } />
			</div>
		);
	} else if ( comment.isDeleted ) {
		return <div />;
	} else if ( comment.commentType === "STREAM_DONATION" ) {
		return comment.topDonation === 1 || isStudioPage ? (
			<LargeStickerComment
				data             = { comment }
				isSmallSticker   = { comment.topDonation === 0 }
				sayThanksHandler = { sayThanksHandler }
				showThanksBtn    = { showThanksBtn }
				userPopover      = { userPopover }
			/>
		) : (
			<SmallStickerComment data = { comment } />
		);
	} else if ( comment.commentType === "MAGIC_CHAT" ) {
		return (
			<MagicChatComment
				data             = { comment }
				emotesList       = { emotesList }
				sayThanksHandler = { sayThanksHandler }
				showThanksBtn    = { showThanksBtn }
				userPopover      = { userPopover }
			/>
		);
	} else {
		return (
			<NormalComment
				data              = { comment }
				emotesList        = { emotesList }
				hideMenuOptionBtn = { hideMenuOptionBtn }
				isModerator       = { isModerator }
				isPopUpOpen       = { isPopUpOpen }
				isStreamer        = { isStreamer }
				onClickOptions    = { onClickOptions }
				userPopover       = { userPopover }
			/>
		);
	}
};

export default Component;
